"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const ThemeProvider_1 = require("../../utils/ThemeProvider");
const StyleUtils_1 = require("../../utils/StyleUtils");
const Utils_1 = require("../../utils/Utils");
const Checkbox_styles_1 = require("./styles/Checkbox.styles");
const __DEV__ = process.env.NODE_ENV !== 'production';
const Checkbox = ({ checked, className, label, labelId, onChange, size, testId }) => {
    const theme = (0, ThemeProvider_1.useTheme)();
    const generatedId = react_1.default.useMemo(() => (0, Utils_1.generateUUID)(), []);
    if (!theme) {
        if (__DEV__) {
            console.error('`Checkbox` component must be a child of a `ThemeProvider`');
        }
        return null;
    }
    const styles = (0, Checkbox_styles_1.getCheckboxStyles)();
    const checkboxId = labelId || generatedId;
    const labelSpanId = label ? `${checkboxId}-label` : undefined;
    const dti = (0, Utils_1.getTestIdAttribute)(testId);
    const handleCheckboxClick = () => {
        onChange(!checked);
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, StyleUtils_1.classNames)(styles.checkboxWrapper, className) }, dti, { children: [(0, jsx_runtime_1.jsx)("div", { role: "checkbox", "aria-checked": checked, "aria-labelledby": labelSpanId, tabIndex: 0, className: (0, StyleUtils_1.classNames)(styles.checkbox, size === 'small' && styles.checkboxSmall, checked && styles.checkboxChecked), onClick: handleCheckboxClick, onKeyDown: e => e.key === ' ' && handleCheckboxClick() }), label && ((0, jsx_runtime_1.jsx)("label", { id: labelSpanId, htmlFor: checkboxId, className: styles.label, children: label })), (0, jsx_runtime_1.jsx)("input", { id: checkboxId, type: "checkbox", checked: checked, onChange: e => onChange(e.target.checked), style: {
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    margin: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0,0,0,0)',
                    whiteSpace: 'nowrap',
                    border: 0,
                }, "aria-hidden": "true" })] })));
};
exports.Checkbox = Checkbox;
